"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Question = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const Button_1 = require("./Button");
const Space_1 = require("./Space");
const react_native_1 = require("react-native");
class Question extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                botoesAcao: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                    width: '100%'
                },
                overlay: {
                    flex: 1,
                    backgroundColor: 'rgba(33, 33, 33, 0.7)',
                    alignItems: 'center'
                },
                text: {
                    color: theme.questionTextColor,
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 25 : 16,
                    textAlign: 'center',
                    marginTop: (0, layout_1.isTablet)() ? 15 : 5,
                    width: '100%'
                },
                container: {
                    backgroundColor: theme.backgroundColor1,
                    borderRadius: 6,
                    padding: (0, layout_1.isTablet)() ? 25 : 16,
                    width: (0, layout_1.isTablet)() ? 350 : 250,
                    marginTop: (0, layout_1.isTablet)() ? 250 : 140,
                    alignItems: 'center'
                },
                icon: {
                    color: theme.textColor3,
                    fontSize: (0, layout_1.isTablet)() ? 52 : 42
                }
            });
            return styles;
        };
    }
    render() {
        const { message, textStyle, visible, nativeID, okButton, cancelButton } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.Modal, { animationType: "fade", transparent: true, visible: visible },
            React.createElement(react_native_1.View, { style: [styles.overlay], nativeID: nativeID },
                React.createElement(react_native_1.View, { style: styles.container },
                    React.createElement(FontAwesome_1.default, { name: 'question-circle', style: styles.icon }),
                    React.createElement(react_native_1.Text, { style: [styles.text, textStyle] }, message),
                    React.createElement(Space_1.Space, null),
                    React.createElement(react_native_1.View, { style: styles.botoesAcao },
                        React.createElement(Button_1.Button, { text: cancelButton.text, onPress: cancelButton.onPress, style: [
                                { flex: 1, marginRight: (0, layout_1.isTablet)() ? 13 : 8 },
                                cancelButton.style
                            ], textStyle: cancelButton.textStyle, primary: false, nativeID: cancelButton.nativeID }),
                        React.createElement(Button_1.Button, { text: okButton.text, onPress: okButton.onPress, style: [
                                { flex: 1, marginLeft: (0, layout_1.isTablet)() ? 13 : 8 },
                                okButton.style
                            ], textStyle: okButton.textStyle, primary: true, nativeID: okButton.nativeID }))))));
    }
}
exports.Question = Question;
